import jApi from './jApi';

export default {
  createForm(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/set', req)
      .then(res => res.data);
  },

  createRecord(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/studio/record/set', req)
      .then(res => res.data);
  },

  deleteForm(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/data/delete', { params })
      .then(res => res.data);
  },

  truncateForm(params) {
    const api = jApi.generateApi();
    return api.post(`/nocode/record/clear?tablegroup_id=${params.tablegroup_id}&form_data_id=${params.form_data_id}`, {})
      .then(res => res.data);
  },

  deleteRecord(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/studio/record/delete', { params })
      .then(res => res.data);
  },

  listForm(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/data/fetch', { params })
      .then(res => res.data);
  },

  getListRecordByFormDataId(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/record/fetch', { params })
      .then(res => res);
  },

  getCountRecordFormData(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/record/count', req)
      .then(res => res);
  },

  getListPosition(req) {
    const api = jApi.generateApi();
    return api.post('/jojoflow/organigram/list', req)
      .then(res => res.data);
  },

  getListRule(req) {
    const api = jApi.generateApi();
    return api.post('/jojoflow/rule/list', req)
      .then(res => res.data);
  },

  getFormData(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/record/form', { params })
      .then(res => res.data);
  },

  // addColumn(req, id) {
  //   const api = jApi.generateApi();
  //   return api.post(`/nocode/data/add-column?formdata_id=${id}`, req)
  //     .then(res => res.data);
  // },

  // updateColumn(req, id, name) {
  //   const api = jApi.generateApi();
  //   return api.post(`/nocode/data/update-column?formdata_id=${id}&name=${name}`, req)
  //     .then(res => res.data);
  // },

  // deleteColumn(params) {
  //   const api = jApi.generateApi();
  //   return api.delete('/nocode/data/delete-column', { params })
  //     .then(res => res.data);
  // },

  addColumn(req, id) {
    const api = jApi.generateApi();
    return api.post(`/nocode/data/column/add?formdata_id=${id}`, req)
      .then(res => res.data);
  },

  updateColumn(req, id, name) {
    const api = jApi.generateApi();
    return api.post(`/nocode/data/column/update?formdata_id=${id}&name=${name}`, req)
      .then(res => res.data);
  },

  deleteColumn(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/data/column/delete', { params })
      .then(res => res.data);
  },

  // Data Group
  listDataGroupByCompanyId(data) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/data/tablegroup/fetch-by-company-id', { params: data })
      .then(res => res.data);
  },

  listDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/fetch', req)
      .then(res => res.data);
  },

  createDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/create', req)
      .then(res => res.data);
  },

  updateNameDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/rename', req)
      .then(res => res.data);
  },

  updateDescDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/update/description', req)
      .then(res => res.data);
  },

  deleteDataGroup(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/data/tablegroup/delete', { params })
      .then(res => res.data);
  },

  listTableByGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/fetch-by-table-groupID', req)
      .then(res => res.data);
  },

  listTableByGroupV2(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/fetch-by-table-groupID-v2', req)
      .then(res => res.data);
  },

  assignDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/assign', req)
      .then(res => res.data);
  },

  // Privilege
  listPrivilegeByGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/studio/data/tablegroup/list-privilege-by-table-group', req)
      .then(res => res.data);
  },

  listPrivilegeByUser(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/data/tablegroup/get-privilege-by-user', { params })
      .then(res => res.data);
  },

  listPrivilegeByMe(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/data/tablegroup/get-privilege-by-me', { params })
      .then(res => res.data);
  },

  addPrivilege(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/add-privilege', req)
      .then(res => res.data);
  },

  removePrivilege(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/tablegroup/remove-privilege', req)
      .then(res => res.data);
  },

  deletePrivilege(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/data/tablegroup/delete-user-privilege', { params })
      .then(res => res.data);
  },

  // Form Data New
  createTable(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/create', req)
      .then(res => res.data);
  },

  updateTable(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/update', req)
      .then(res => res.data);
  },

  deleteTable(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/data/delete-v2', { params })
      .then(res => res.data);
  },

  setPrimaryKey(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/column/set-primarykey', req)
      .then(res => res.data);
  },

  removePrimaryKey(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/data/column/remove-primarykey', req)
      .then(res => res.data);
  },

  listUser(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/user/list', req)
      .then(res => res.data.data);
  },

  getListServiceSwitcher() {
    const api = jApi.generateApi();
    return api.get('/nocode/switcher/service-list')
      .then(res => res.data);
  },

  getFormDataSwitcher(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/switcher/data/get', { params })
      .then(res => res.data);
  },

  getAutomationSwitcher(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/switcher/automation/get', { params })
      .then(res => res.data);
  },

  setFormDataSwitcher(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/switcher/data/update', req)
      .then(res => res.data);
  },

  setAutomationSwitcher(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/switcher/automation/set', req)
      .then(res => res.data);
  },

  requestOtpArchiveData(id) {
    const api = jApi.generateApi();
    return api.get(`/archive-data/${id}/request-otp`)
      .then(res => res.data);
  },

  archiveData(id, req) {
    const api = jApi.generateApi();
    return api.post(`/archive-data/${id}`, req)
      .then(res => res.data);
  },

  requestOtpPurgingData(id) {
    const api = jApi.generateApi();
    return api.get(`/purge-data/${id}/request-otp`)
      .then(res => res.data);
  },

  purgingData(id, req) {
    const api = jApi.generateApi();
    return api.post(`/purge-data/${id}`, req)
      .then(res => res.data);
  },

  getListAuditLogTable(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/form/auditlog/by_form', { params })
      .then(res => res.data);
  },

  getListArchiveData(archiveId) {
    const api = jApi.generateApi();
    return api.get(`archive-data/${archiveId}`)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiForm.js